import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Box, UserManual } from "../../../../components";
import { MyRequestsTable, RequestsTable } from "./components";
import CreateRequestButton from "../../components/CreateRequestButton";
import { Routes } from "../../../../AppRoutes";

const EmployeeConfirmation = withProcedureWraper(() => {
  const history = useHistory();

  return (
    <div className="pd15">
      <UserManual
        title="XÁC NHẬN NHÂN VIÊN"
        icon={<AiOutlineCheckCircle size={26} />}
      />
      <Box
        title="Yêu cầu của tôi"
        titleRight={
          <CreateRequestButton
            onClick={() => history.push(Routes.employeeConfirmationCreate.path)}
          />
        }
      >
        <MyRequestsTable />
      </Box>
      <Box title="Yêu cầu cần phê duyệt">
        <RequestsTable />
      </Box>
    </div>
  );
});

export default EmployeeConfirmation;
